/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Select_Folder_TitleInputs */

const en_audio_embed_export_select_folder_title = /** @type {(inputs: Audio_Embed_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed Audio - Select Target Folder`)
};

const fr_audio_embed_export_select_folder_title = /** @type {(inputs: Audio_Embed_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrer l'audio - Sélectionner le dossier cible`)
};

const de_audio_embed_export_select_folder_title = /** @type {(inputs: Audio_Embed_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio einbetten – Zielordner auswählen`)
};

const it_audio_embed_export_select_folder_title = /** @type {(inputs: Audio_Embed_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora audio - Seleziona la cartella di destinazione`)
};

const ru_audio_embed_export_select_folder_title = /** @type {(inputs: Audio_Embed_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроить аудио — Выберите целевую папку`)
};

const es_audio_embed_export_select_folder_title = /** @type {(inputs: Audio_Embed_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar audio - Seleccionar carpeta de destino`)
};

const zh_cn2_audio_embed_export_select_folder_title = /** @type {(inputs: Audio_Embed_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入音频 - 选择目标文件夹`)
};

const ja_audio_embed_export_select_folder_title = /** @type {(inputs: Audio_Embed_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声埋め込み - 対象フォルダを選択`)
};

const hi_audio_embed_export_select_folder_title = /** @type {(inputs: Audio_Embed_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो एम्बेड करें - लक्षित फ़ोल्डर चुनें`)
};

const pt_pt2_audio_embed_export_select_folder_title = /** @type {(inputs: Audio_Embed_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporar áudio - Selecione a pasta de destino`)
};

/**
* | output |
* | --- |
* | "Embed Audio - Select Target Folder" |
*
* @param {Audio_Embed_Export_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_select_folder_title = /** @type {((inputs?: Audio_Embed_Export_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_select_folder_title(inputs)
	if (locale === "de") return de_audio_embed_export_select_folder_title(inputs)
	if (locale === "it") return it_audio_embed_export_select_folder_title(inputs)
	if (locale === "ru") return ru_audio_embed_export_select_folder_title(inputs)
	if (locale === "es") return es_audio_embed_export_select_folder_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_select_folder_title(inputs)
	if (locale === "ja") return ja_audio_embed_export_select_folder_title(inputs)
	if (locale === "hi") return hi_audio_embed_export_select_folder_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_select_folder_title(inputs)
	return en_audio_embed_export_select_folder_title(inputs)
});